module.exports = __webpack_public_path__ + "img/white_pearl.a3a87c6b.jpg";